export default "__VITE_ASSET__5_WT1Vk$__"